export const isUseableType = (value) => {
  return (typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "object") &&
    value !== undefined &&
    value !== null
    ? true
    : false;
};
